module.exports = __webpack_public_path__ + "img/imgbig-Right-Bicep.e3fbedbc.png";